import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum AccrualLedgerSettingsColumn {
    ENTITY = "entity",
    ACTION = "action",
}

const EntityColumnSchema = ColumnSchema.extend({
    id: z.literal(AccrualLedgerSettingsColumn.ENTITY),
});

const ActionColumnSchema = ColumnSchema.extend({
    id: z.literal(AccrualLedgerSettingsColumn.ACTION),
});

export const AccrualLedgerSettingsViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ACCRUAL_LEDGER_SETTINGS),
    columns: z.array(
        z.discriminatedUnion("id", [EntityColumnSchema, ActionColumnSchema]),
    ),
});

export type AccrualLedgerSettingsView = z.infer<
    typeof AccrualLedgerSettingsViewSchema
>;
